import { loan_application } from '@axo/shared/data-access/types';
import { DebtDetails } from '../DebtDetails';

type DebtListProps = {
  debts: Array<loan_application.Debt & { id?: string }>; // react hook form internal id
  onEdit?: (index: number) => void;
  onRemove?: (index: number) => void;
  editingDebtIndex?: number;
  hasDebtCollection?: boolean;
};
export const DebtList = ({
  debts,
  editingDebtIndex,
  hasDebtCollection,
  onEdit,
  onRemove,
}: DebtListProps) => {
  return (
    <>
      {debts.map((field, index) => {
        if (field?.Type === loan_application.DebtType.Collection) return null;

        const debtNumber = hasDebtCollection ? index : index + 1;

        return (
          <DebtDetails
            key={field?.id}
            index={index}
            debtNumber={debtNumber}
            editingDebtIndex={editingDebtIndex}
            onEdit={() => onEdit?.(index)}
            onRemove={() => onRemove?.(index)}
          />
        );
      })}
    </>
  );
};
